// extracted by mini-css-extract-plugin
export default {"error":"SignUpSignIn_error__ZNXCI"};